import styled from 'styled-components';
import { colors } from 'View/Theme';
import { asRem } from 'utils';
import { Section } from 'View/Container';
import { mediaQueries } from 'utils/Constants/Breakpoints';

export default styled(Section).attrs({
  className: 'audio-samples-section',
  backgroundColor: 'c800',
  type: 'full-width',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: ${asRem(60)} 0 ${asRem(30)} 0;

  ${mediaQueries.md} {
    padding: ${asRem(50)} 0 ${asRem(30)} 0;
  }

  .audio-samples-indicators {
    position: relative !important;
    display: block;
    width: auto;
    z-index: 1;
    justify-content: center;
    align-items: center;
    height: ${asRem(30)};

    button {
      border-radius: 50%;
      width: 12px;
      height: 12px;
      margin: 0 ${asRem(6)};
    }
  }

  .carousel-indicators [data-bs-target] {
    opacity: 0.8;
    background-color: ${colors.sleep.blue.c300};
    transition: background-color 0.3s ease;
  }

  .carousel-indicators .active {
    background-color: ${colors.sleep.blue.c100};
  }
`;
